import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api/course_item`;

// url的参数id
export async function get_list(
  i_courseID: string,
  i_gradeList?: any,
  offset = 0,
  limit = 9999,
  sort?: any,
  order?: any,
  is_cache?: any
) {
  return client.post({
    url: `${url}/get_list`,
    form: {
      course_id: i_courseID,
      grade: Array.isArray(i_gradeList) ? i_gradeList.join(',') : i_gradeList,
      offset,
      limit,
      sort,
      order,
      is_cache
    }
  });
}
export async function remove(i_cItemID = null) {
  if (!i_cItemID) {
    return;
  }
  return client.post({
    url: `${url}/delete`,
    form: {
      id: i_cItemID
    }
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get_list,
  remove
};
